import React from "react";
import PropTypes from "prop-types";
import { Grid, Label } from "semantic-ui-react";
import Gravatar from "_views/gravatar";
import UserInfo from "_views/userInfo";
import LicenseItem from "_views/license";
import { PAGES } from "_constants";

const NoEndUser = () => (
  <Label>
    <Gravatar
      gravatar="missingUser"
      size={20}
      circular={true}
      style={{ display: "inline-block", verticalAlign: "top", paddingRight: "0.5em" }}
    />
    <div style={{ display: "inline-block" }}>
      Unclaimed
    </div>
  </Label>
);

const License = (props) => {
  const license = props.license || {};

  const handleInfoClick = () => {
    props.setNavigation({
      pageName: PAGES.USERS,
      ids: [license.user && license.user._id]
    });
  };

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={3}>
          <UserInfo
            onClick={handleInfoClick}
            user={license.user}
            whenNull={<NoEndUser />}
          />
        </Grid.Column>
        <Grid.Column width={13}>
          <LicenseItem {...props} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

License.propTypes = {
  license: PropTypes.object.isRequired,
  onRefreshLicense: PropTypes.func.isRequired,
  onRemoveLicense: PropTypes.func.isRequired,
  onModifyLicense: PropTypes.func.isRequired,
  onAddSublicense: PropTypes.func.isRequired,
  onRemoveSublicense: PropTypes.func.isRequired,
  onRemoveLicenseMachine: PropTypes.func.isRequired,
  onDeactivateLicenseUpgrade: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default License;



// WEBPACK FOOTER //
// ./webAdmin/components/licenses/license.js